<template>
    <v-form ref="form">
        <v-row> 
            <v-col>
                <v-autocomplete
                    label="Item"
                    dense
                    hide-details="auto"
                    outlined
                    :rules="[isRequired]"
                    v-model="form.item_id"
                    @update:search-input="itemSearch"
                    :items="items"
                    :loading="itemsLoading"
                    item-text="name"
                    item-value="id"
                    clearable
                    disabled
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Account"
                    dense
                    hide-details="auto"
                    outlined
                    :rules="[isRequired]"
                    :loading="accountLoading"
                    @update:search-input="accountSearch"
                    v-model="form.account_id"
                    :items="accounts"
                    item-value="id"
                    item-text="display_name"
                    clearable
                    :disabled="edit"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row> 
            <v-col>
                <v-autocomplete
                    label="Item Account Type"
                    dense
                    hide-details="auto"
                    outlined
                    :rules="[isRequired]"
                    v-model="form.item_account_type_id"
                    @update:search-input="itemAccountTypeSearch"
                    :loading="itemAccountTypeLoading"
                    :items="itemAccountTypes"
                    item-value="id"
                    item-text="name"
                    clearable
                >
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
       
</template>

<script>
import { isRequired } from './../../utils/validations'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "ItemAccountFrom",
    props: {
        value: Object,
        edit: Boolean
    },
    data() {
        return {
            form: {
                item_id: null,
                item_account_type_id: null,
                account_id: null
            }
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    methods: {
        isRequired,
        ...mapActions({
            itemSearch: "stock/item/search/get",
            accountSearch: "stock/account/get",
            itemAccountTypeSearch: 'stock/itemAccountType/get',
        }),
        validate() {
            return this.$refs.form.validate()
        }
        
    },
    computed: { 
        ...mapGetters({
            accounts: 'stock/account/data',
            items: 'stock/item/search/data',
            accountLoading: 'stock/account/loading',
            itemsLoading: 'stock/item/search/loading',
            itemAccountTypes :'stock/itemAccountType/data',
            itemAccountTypeLoading : "stock/itemAccountType/loading"
        })
    },
    mounted  () {
        if(this.value) {
            this.form = {...this.form, ...this.value}
        }    
    }
}
</script>

<style>
</style>